import { createElement  } from 'react'
import { useController } from 'react-hook-form'

const AdditionField = ({
  type,
  label,
  name,
  placeholder,
  rules,
  control,
  defaultValue,
  editors,
  compact,
  ...props
}) => {
  const { field } = useController({
    name,
    control,
    defaultValue,
    rules,
  })
  return createElement(editors[type] || editors.text, {
    ...field,
    label,
    placeholder: placeholder ?? label,
    key: field.name,
    control,
    compact,
    ...props,
  })
}

export default AdditionField
